import { batch as viewBatch } from "@mixitone/mvc";

/**
 * Wrap a whole action in batch mode
 */
export function withBatch(_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
  const originalMethod = descriptor.value;

  descriptor.value = function (...args: any[]) {
    const batchFunction = async () => {
      return originalMethod.apply(this, args);
    };

    return viewBatch(batchFunction);
  };
}
